import { FormikProps } from "formik";

import { AppDispatch, setVerificationStatus } from "../../../store";
import { bankAccounts } from "../../constants";

import { PaymentInformation } from "../../../../../MPP-Common-SPA/utils/generator/sectionModels";
import { BankAccount } from "../../../../../MPP-Common-SPA/utils/generator/applicationModels";

export interface HandlerDependencies {
  form: FormikProps<any>;
  dispatch: AppDispatch;
}

// Payment Handlers
export const createPaymentHandlers = ({
  form,
  dispatch,
}: HandlerDependencies) => {
  function handleVerificationChange(name: string, value: any) {
    const verificationStatus = parseInt(value);

    form.setFieldValue("verificationStatus", verificationStatus);
    dispatch(setVerificationStatus(verificationStatus));

    if (verificationStatus !== 1) {
      form.setFieldValue(
        "PaymentInformation",
        new PaymentInformation(form.values.PersonalInformation)
      );
    } else {
      form.setFieldValue("PaymentInformation", {});
    }

    setTimeout(() => form.validateForm(), 0);
  }

  function handleBankAccountDetailsToggle(name: string, value: string) {
    setBankAccountFields(bankAccounts[value]);
  }

  function setBankAccountFields(bankAccount: BankAccount) {
    form.setFieldValue(
      "PaymentInformation.institutionNumber",
      bankAccount.institutionNumber
    );
    form.setFieldValue(
      "PaymentInformation.transitNumber",
      bankAccount.transitNumber
    );
    form.setFieldValue(
      "PaymentInformation.bankAccount",
      bankAccount.accountNumber
    );
    form.setFieldValue(
      "PaymentInformation.confirmBankAccount",
      bankAccount.accountNumber
    );
    form.setFieldValue(
      "PaymentInformation.bankName",
      bankAccount.bankName
    )
  }

  function handleETransferChange(name: string, value: any) {
    if (name === "usePersonalEmail") {
      const usePersonalEmail = value;
      syncEmailFields(usePersonalEmail);
    } else {
      setPaymentInformationEmailFields();
    }
  }

  function handlePaymentInformationMobileAndPhoneChange(
    name: string,
    value: any
  ) {
    if (name === "usePersonalNumber") {
      const usePersonalNumber = value;
      syncMobileFields(usePersonalNumber);
    } else {
      const personalMobile = form.values.PersonalInformation.mobile;
      const personalPhone = form.values.PersonalInformation.phone;
      setPaymentInformationMobileAndPhoneFields(personalMobile, personalPhone);
    }
  }

  function setPaymentInformationEmailFields() {
    const personalEmail = form.values.PersonalInformation.email;
    form.setFieldValue("PaymentInformation.email", personalEmail);
    form.setFieldValue("PaymentInformation.confirmEmail", personalEmail);
  }

  function setPaymentInformationMobileAndPhoneFields(
    personalMobile: string,
    personalPhone: string
  ) {
    form.setFieldValue(
      "PaymentInformation.mobile",
      personalMobile || personalPhone
    );
    form.setFieldValue(
      "PaymentInformation.confirmMobile",
      personalMobile || personalPhone
    );
  }

  function syncMobileFields(usePersonalNumber: boolean) {
    if (usePersonalNumber) {
      const personalMobile = form.values.PersonalInformation.mobile;
      const personalPhone = form.values.PersonalInformation.phone;
      form.setFieldValue("PaymentInformation.usePersonalNumber", true);
      form.setFieldValue(
        "PaymentInformation.mobile",
        !!personalMobile ? personalMobile : personalPhone
      );
      form.setFieldValue(
        "PaymentInformation.confirmMobile",
        !!personalMobile ? personalMobile : personalPhone
      );

      setTimeout(() => form.validateForm(), 0);
    } else {
      form.setFieldValue("PaymentInformation.usePersonalNumber", false);
    }
  }

  function syncEmailFields(usePersonalEmail: boolean) {
    if (usePersonalEmail) {
      const personalEmail = form.values.PersonalInformation.email;
      form.setFieldValue("PaymentInformation.usePersonalEmail", true);
      form.setFieldValue("PaymentInformation.email", personalEmail);
      form.setFieldValue("PaymentInformation.confirmEmail", personalEmail);

      setTimeout(() => form.validateForm(), 0);
    } else {
      form.setFieldValue("PaymentInformation.usePersonalEmail", false);
    }
  }

  return {
    handleVerificationChange,
    handleBankAccountDetailsToggle,
    handleETransferChange,
    handlePaymentInformationMobileAndPhoneChange,
  };
};
